import { type CSSProperties, type ReactElement } from 'react';

import { extractDataAttributes } from '../../utils/extract-data-attributes.js';
import type { DataTablePaginationProps } from '../features/Pagination/pagination-types.js';

/**
 * Processes the pagination slot.
 *
 * @param paginationSlot - Datatable pagination slot
 * @returns processed pagination slot data
 * @internal
 */
export function usePaginationSlot(
  paginationSlot: ReactElement<DataTablePaginationProps> | null,
): {
  paginationConsumerId?: string;
  paginationDataTestId?: string;
  paginationConsumerStyle?: CSSProperties;
  paginationConsumerClassName?: string;
  paginationDataAttributes: Record<string, unknown>;
} {
  const {
    id: paginationConsumerId,
    'data-testid': paginationDataTestId,
    style: paginationConsumerStyle,
    className: paginationConsumerClassName,
    ...remainingProps
  } = paginationSlot?.props ?? {};

  const paginationDataAttributes = extractDataAttributes(remainingProps);

  return {
    paginationConsumerId,
    paginationDataTestId,
    paginationConsumerStyle,
    paginationConsumerClassName,
    paginationDataAttributes,
  };
}
